export const getBundlesData = (state) => state?.bundleManager?.bundleResponse ?? {};
export const getBundlesFetching = (state) => state?.bundleManager?.bundleFetching ?? false;
export const getSingleBundlesFetching = (state) => state?.bundleManager?.singleFetching;
export const getDisabledBundlesData = (state) => state?.bundleManager?.disabledBundlesData ?? {};
